<template>
  <div class="py-4 container-fluid">
    <div v-if="!isEditing" class="mt-4 row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Products List</h5>
            <router-link to="/ecommerce/products/new-product" class="btn btn-sm bg-gradient-success">
              New Product
            </router-link>
          </div>
          <div class="table-responsive">
            <table id="products-datatable" class="table table-flush">
              <thead class="thead-light">
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">ID</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Name</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Original Price</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Discount</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Final Price</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Status</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="product in products" :key="product.id">
                  <td class="text-sm font-weight-normal">{{ product.id }}</td>
                  <td class="text-sm font-weight-normal">{{ product.name }}</td>
                  <td class="text-sm font-weight-normal">{{ product.originalPrice }}</td>
                  <td class="text-sm font-weight-normal">{{ product.discount }}%</td>
                  <td class="text-sm font-weight-normal">{{ product.discountedPrice }}</td>
                  <td class="text-sm font-weight-normal">
                    <span :class="['badge', product.enabled ? 'bg-success' : 'bg-danger']">
                      {{ product.enabled ? 'Active' : 'Disabled' }}
                    </span>
                  </td>
                  <td class="text-sm font-weight-normal">
                    <a href="javascript:;" :data-id="product.id" class="mx-2 edit-btn" data-bs-toggle="tooltip" data-bs-original-title="Edit product">
                      <i class="material-icons text-secondary position-relative text-lg">edit</i>
                    </a>
                    <a href="javascript:;" :data-id="product.id" class="delete-btn" data-bs-toggle="tooltip" data-bs-original-title="Delete product">
                      <i class="material-icons text-secondary position-relative text-lg">delete</i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <edit-product
      v-else
      :product-id="editingProductId"
      @close="onCloseEdit"
    />
  </div>
</template>

<script>
import { DataTable } from "simple-datatables";
import { mapActions, mapGetters } from "vuex";
import EditProduct from "./EditProduct.vue";

export default {
  name: "ProductList",
  components: {
    EditProduct,
  },
  data() {
    return {
      dataTable: null,
      isEditing: false,
      editingProductId: null,
    };
  },
  computed: {
    ...mapGetters("product", {
      products: "getProducts",
    }),
  },
  methods: {
    ...mapActions("product", ["getProducts", "deleteProduct"]),
    initDataTable() {
      if (this.dataTable) {
        this.dataTable.destroy();
      }
      if (document.getElementById("products-datatable")) {
        this.dataTable = new DataTable("#products-datatable", {
          searchable: true,
          fixedHeight: true,
        });

        this.dataTable.dom.addEventListener("click", (event) => {
          const target = event.target.closest(".edit-btn, .delete-btn");
          if (!target) return;

          const id = target.dataset.id;
          if (target.classList.contains("edit-btn")) {
            this.onEdit(id);
          } else if (target.classList.contains("delete-btn")) {
            this.onDelete(id);
          }
        });
      }
    },
    onEdit(id) {
      this.editingProductId = id;
      this.isEditing = true;
    },
    async onCloseEdit() {
      this.isEditing = false;
      this.editingProductId = null;
      await this.getProducts();
      this.$nextTick(() => {
        this.initDataTable();
      });
    },
    async onDelete(id) {
      if (confirm("Are you sure you want to delete this product?")) {
        await this.deleteProduct(id);
        this.$nextTick(() => {
          this.initDataTable();
        });
      }
    }
  },
  async mounted() {
    await this.getProducts();
    this.$nextTick(() => {
      this.initDataTable();
    });
  },
};
</script>
